import { 
    //MeshBasicMaterial,
    MeshToonMaterial,
} from 'three';
//import { AsciiEffect } from 'three/examples/jsm/effects/AsciiEffect.js';

var AvailableMaterials = [
    //{ title: "Mesh Basic", type: MeshBasicMaterial, settings: {} },
    { title: "Mesh Toon Material", type: MeshToonMaterial, settings: {} },
];

var MaterialsNames = AvailableMaterials.map(elm =>  elm.title);
//console.log("Material Names:", MaterialsNames);

export { AvailableMaterials, MaterialsNames };
